import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Modal from '../../../components/modal/index';
import ConfirmationMessage from '../../../components/confirmation-message/index';
import { Warning } from '../../../helpers/icon-dictionary';
import messages from '../messages';
import PortalCommunication from '../../../portal-comms';

const ExtendResultError = (props) => {
    const { intl,
        extendingResultsStatusType
    } = props;

    let confirmation = <div />;

    switch (extendingResultsStatusType) {
    case 'ResultAlreadyExtended':
        confirmation = (<ConfirmationMessage
            handleOnCloseModal={() => { PortalCommunication.navigateToLandingScreen('Rollover'); }}
            icon={Warning}
            title={intl.formatMessage(messages.resultsAlreadyExtended)}>
            {intl.formatMessage(messages.resultsAlreadyExtendedSummary)}
        </ConfirmationMessage>);
        break;

    case 'OutOfExtendPeriod':
        confirmation = (<ConfirmationMessage
            handleOnCloseModal={() => { PortalCommunication.navigateToLandingScreen('Rollover'); }}
            icon={Warning}
            title={intl.formatMessage(messages.extendPeriodExpired)}>
            {intl.formatMessage(messages.extendPeriodExpiredSummary)}
        </ConfirmationMessage>);
        break;

    case 'RolloverRequired':
        confirmation = (<ConfirmationMessage
            handleOnCloseModal={() => { PortalCommunication.navigateToLandingScreen('Rollover'); }}
            icon={Warning}
            title={intl.formatMessage(messages.rolloverNotCompleted)}>
            {intl.formatMessage(messages.rolloverNotCompletedSummary)}
        </ConfirmationMessage>);
        break;

    default:
        confirmation = <div />;
        break;
    }

    return (<Modal show={extendingResultsStatusType !== 'IsExtendable'}>
        {confirmation}
    </Modal>);
};

ExtendResultError.propTypes = {
    intl: intlShape.isRequired,
    extendingResultsStatusType: PropTypes.string
};

export default injectIntl(ExtendResultError);



// WEBPACK FOOTER //
// ./app/components/extend-result/modals/error.js